import { render, staticRenderFns } from "./MaterialTemplatesPage.vue?vue&type=template&id=2a3a0f64&scoped=true&"
import script from "./MaterialTemplatesPage.vue?vue&type=script&lang=ts&"
export * from "./MaterialTemplatesPage.vue?vue&type=script&lang=ts&"
import style0 from "./MaterialTemplatesPage.vue?vue&type=style&index=0&id=2a3a0f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a0f64",
  null
  
)

export default component.exports